import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { object, func, string, bool } from 'prop-types';
import { SAVE_LOCATION_ACCOUNT } from '../sagas/account';
import { isSavedLocation } from '../core/util/account';
import withAuthentication from '../core/login/withAuthentication';

const Heart = styled.img`
  height: 16px;
  width: 16px;
  vertical-align: middle;
`;

class SaveIcon extends PureComponent {
  static propTypes = {
    className: string,
    location: object,
    accountSummary: object,
    setSavedLocation: func,
    noAction: bool,
    unsavedHeart: string,
    savedHeart: string,
    isLoggedIn: bool.isRequired,
  };

  static defaultProps = {
    savedHeart: '/images/icons/Icon-Save-Filled.svg',
    unsavedHeart: '/images/icons/Icon-Save.svg',
  };

  getSrcImg = () => (this.isSavedLocation() ? this.props.savedHeart : this.props.unsavedHeart);

  isSavedLocation = () => {
    const { location, accountSummary } = this.props;
    return isSavedLocation(location, accountSummary);
  };

  handleClick = e => {
    if (this.props.noAction) return;
    e.preventDefault();
    e.stopPropagation();
    const {
      setSavedLocation,
      accountSummary,
      location: { id: locationId },
      isLoggedIn,
    } = this.props;

    const accountId = accountSummary && accountSummary.id;
    setSavedLocation({
      locationId,
      accountId,
      save: !this.isSavedLocation(),
      isLoggedIn,
    });
  };

  render = () => (
    <Heart
      className={this.props.className}
      onClick={this.handleClick}
      src={this.getSrcImg()}
      alt="save clinic for later"
    />
  );
}

const mapStateToProps = state => ({
  accountSummary: state.account.summary,
});

const mapDispatchToProps = dispatch => ({
  setSavedLocation: saveData => dispatch({ type: SAVE_LOCATION_ACCOUNT, ...saveData }),
});

export default withAuthentication(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SaveIcon)
);
